export default "__VITE_ASSET__CfIhIlwK__"